module.exports = __webpack_public_path__ + "img/LTS_SAICA_Projects.e9384ed1.gif";